<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true"
  [hidden]="isAuthValidating"
>
  <mc-loading-indicator class="tetsst" fit="large" label=""> </mc-loading-indicator>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<!-- ======= Auth Validation Overlay (shown only while /ValidateToken is in flight) ======= -->
<div class="auth-spinner-wrapper">
  <ngx-spinner name="authSpinner" bdColor="rgba(0, 36, 61, 0.85)" [fullScreen]="true">
    <div class="app-loading-card">
      <img src="./assets/logos/Primary_Logo_Positive.svg" alt="Maersk" class="app-loading-logo" />
      <p class="app-loading-appname">Oil Analysis</p>
      <mc-loading-indicator fit="large" variant="ring" label="Loading" hiddenlabel></mc-loading-indicator>
      <p class="app-loading-title">Just a moment</p>
      <p class="app-loading-subtext">Validating your session...</p>
    </div>
  </ngx-spinner>
</div>

<router-outlet *ngIf="!isIframe"></router-outlet>

<!-- <div color="primary">
  
    <button *ngIf="!loginDisplay">Login</button>
    <div >
      <button  (click)="loginRedirect()">Login using Redirect</button>
      <button  (click)="loginPopup()">Login using Popup</button>
    </div>
  
    <button  *ngIf="loginDisplay">Logout</button>
 
      <button (click)="logout()">Logout using Redirect</button>
      <button (click)="logout(true)">Logout using Popup</button>
  
</div>
  <div class="container">
    <router-outlet *ngIf="!isIframe"></router-outlet>
  </div> -->
